import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import {
  getRiskScoreClassification,
  getRiskScoreClassificationShortName,
  riskAssessmentColors,
} from "../utils/riskAssessments";

import DetailCell from "./DetailCell";
import { RiskAssessmentData } from "../features/data/patientApiSlice";
import { createStyleSheet } from "../utils/styles";
import { formatDate } from "../utils/dates";
import { useTranslation } from "react-i18next";

const MultiRiskAssessmentCell = (props: {
  riskAssessments?: RiskAssessmentData[];
  first?: boolean;
}) => {
  const { riskAssessments, first } = props;
  const { t } = useTranslation("Patient");
  return (
    <DetailCell title={t("healthScores")} first={first}>
      <Table>
        <TableBody>
          {riskAssessments?.map((riskAssessment) => (
            <TableRow key={riskAssessment.type}>
              <TableCell sx={styles.plainCell}>
                <Typography variant="detailCellBody">
                  {t(`riskAssessmentTypes:${riskAssessment.type}:title`)}
                </Typography>
              </TableCell>
              <TableCell sx={styles.plainCell}>
                <Typography
                  variant="detailCellBody"
                  sx={{
                    ...styles.classificationText,
                    color:
                      riskAssessmentColors[
                        getRiskScoreClassification(riskAssessment)
                      ],
                  }}
                >
                  {getRiskScoreClassificationShortName(t, riskAssessment)}
                </Typography>
              </TableCell>
              <TableCell sx={styles.plainCell}>
                {riskAssessment?.timestamp ? (
                  <Typography
                    variant="detailCellTitle"
                    sx={styles.timestampText}
                  >
                    {formatDate(new Date(riskAssessment.timestamp))}
                  </Typography>
                ) : null}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </DetailCell>
  );
};

const styles = createStyleSheet({
  plainCell: {
    padding: 0,
    borderBottom: "none",
  },
  classificationText: {
    marginLeft: 1,
  },
  timestampText: {
    display: "inline",
    paddingLeft: 1,
    marginLeft: 1,
    borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
  },
});

export default MultiRiskAssessmentCell;
